
export const setUserAction = (setUserAction) => { 

  return{
      type: 'setUserAction',
      payload: { setUserAction }
  };
};